const AnAlertBarManager = {

	showAlertBar(ref, params) {
		if (ref && typeof ref.show === 'function') {
			ref.show(params);
		}
	},
};

export default AnAlertBarManager